export default __webpack_public_path__ + "static/media/AvantGarde-Regular.766e0720.ttf";